/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * Only 'active' is allowed via PATCH (system-only sets 'invalid'). Use this to re-enable a workspace after fixing the underlying failure.
 */
export type UpdateMeetWorkspaceBodyState =
  (typeof UpdateMeetWorkspaceBodyState)[keyof typeof UpdateMeetWorkspaceBodyState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMeetWorkspaceBodyState = {
  active: "active"
} as const
